import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { addSearch, fetchSavedSearches } from '../../actions/savedSearches';
import { SavedSearchModal } from '../search/results-ts';
import { findExistingAlert } from '../../utils/alertComparison';
import i18n from '../../i18n';
import UserModel from '../../models/User';
import Analytics from '../../utils/analytics';
import Screen from '../../utils/Screen';
import { AlertDialog, Text } from '@homeexchange/design';
import { Icon } from '@homeexchange/design';
import { IconBellAnimated } from '../icons/IconBellAnimated';

export class Alert extends React.PureComponent {
    static propTypes = {
        user: PropTypes.instanceOf(UserModel),
        alerts: PropTypes.arrayOf(PropTypes.object),
        search: PropTypes.object.isRequired,
        iconOnly: PropTypes.bool,
        addAlert: PropTypes.func,
        fetchSavedSearches: PropTypes.func,
        currentFilters: PropTypes.object,
        currentQueryString: PropTypes.string
    };

    constructor(props) {
        super(props);
        const { alerts, search } = props;
        this.state = {
            success: false,
            errorPopup: false,
            alert: this.getExistingAlert(alerts, search),
            createAlert: null,
            isOpen: false,
            openModalAlertAlreadyExists: false
        };
        this.saveSearch = this.saveSearch.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { alerts, search } = nextProps;
        this.setState({
            alert: this.getExistingAlert(alerts, search)
        });
    }

    getExistingAlert(alerts, search) {
        return findExistingAlert(alerts, search);
    }

    saveSearch(event) {
        event.preventDefault();

        const { search, user } = this.props;
        const { alert } = this.state;

        if (!user) {
            $('.btn-signup').trigger('click');
            return;
        }

        Analytics.trackGTM('SearchResults', {
            event_data: {
                action: 'click',
                area: 'search',
                text: 'save_this_destination',
                origin: 'top_menu',
                search_value: search.query
            }
        });

        if (alert) {
            this.setState({
                openModalAlertAlreadyExists: true
            });
        } else {
            const filtersToSave = this.props.currentFilters || {};
            const queryString = this.props.currentQueryString || search.query;
            this.props.addAlert(queryString, filtersToSave).then((response) => {
                this.setState({
                    createAlert: response,
                    isOpen: true
                });
                this.props.fetchSavedSearches();
            });
        }
    }

    render() {
        const { user } = this.props;
        const { alert } = this.state;

        if (!user) {
            return null;
        }

        if (!this.props.search.query || this.props.search.query.length === 0) {
            return null;
        }

        return (
            <>
                <div
                    className={`save-destination-chip${alert ? ' is-selected' : ''}`}
                    onClick={this.saveSearch}
                    role="button"
                    tabIndex={0}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            this.saveSearch(e);
                        }
                    }}
                >
                    {alert ? (
                        <Icon name="BellOff" size="large" />
                    ) : Screen.matchesMedia('(prefers-reduced-motion: reduce)') ? (
                        <Icon name="Bell" size="large" />
                    ) : (
                        <IconBellAnimated />
                    )}
                    <span className="save-destination-chip-label">
                        {alert
                            ? i18n.t('search:alert_search_already_saved')
                            : i18n.t('search:alert.save_search')}
                    </span>
                </div>
                <SavedSearchModal
                    isOpen={this.state.isOpen}
                    onClose={() => this.setState({ isOpen: false })}
                    createdAlert={this.state.createAlert}
                />
                <AlertDialog
                    isOpen={this.state.openModalAlertAlreadyExists}
                    onConfirmAction={() => this.setState({ openModalAlertAlreadyExists: false })}
                    confirmActionText={'OK'}
                    title={i18n.t('user:modal_travelWishlist_alreadySaved_title')}
                    onDismissAction={() => (window.location.href = i18n.t('url:saved_search'))}
                    dismissActionText={i18n.t('user:modal_travelWishlist_alreadySaved_cta')}
                    iconStatus="info"
                >
                    <Text>{i18n.t('user:modal_travelWishlist_alreadySaved_body')}</Text>
                </AlertDialog>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    user: state.user,
    homes: state.homes,
    alerts: state.savedSearches,
    currentFilters: state.search?.main?.filters,
    currentQueryString: state.search?.main?.queryString
});

const mapDispatchToProps = (dispatch) => ({
    addAlert: bindActionCreators(addSearch, dispatch),
    fetchSavedSearches: bindActionCreators(fetchSavedSearches, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Alert);
